import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Slider from './components/Slider';
import SitioWeb from './components/SitioWeb';
import LandingPage from './components/LandingPage';
import Ecommerce from './components/Ecommerce';
import Form from './components/Form';
import Footer from './components/Footer';
import WhatsappButton from './components/WhatsappButton';
import UpButton from './components/UpButton';
import Clientes from './components/Clientes';
import ElsaDommarco from './components/ElsaDommarco';
import TeatroColon from './components/TeatroColon';


function App() {
  return (
    <div className='App' id='app' style={{ width: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'rgb(230,230,255)' }}>
      <BrowserRouter>
        <header>
          <Navbar />
        </header>
        <main>
          <Routes>
            <Route path='/*' element={
              <>
                <Slider />
                <SitioWeb />
                <LandingPage />
                <Ecommerce />
                <Clientes/>
                <Form />
                <WhatsappButton />
                <UpButton />
              </>}
              ></Route>
            <Route path='/elsaDommarco' element={<ElsaDommarco/>}></Route>
            <Route path='/teatroColon' element={<TeatroColon/>}></Route>
          </Routes>
        </main>
      </BrowserRouter>
      <footer>
        <Footer />

      </footer>
    </div>
  );
}

export default App;
